import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import {
  CommitmentReminderAction,
  ICommitmentReminder,
  ICommitmentReminderActionItem,
} from 'legacy/lut/services/partner360/commitment/models/ICommitmentReminder'
import React, { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { PartnerCommitmentTranslations } from 'partner360/entities/partnerCompleteness'

import { PlanReviewActions } from '../planReviewActions/PlanReviewActions'

import styles from './ConfirmReviewAction.module.scss'

interface IConfirmReviewActionProps {
  reminder: ICommitmentReminder
  onPlanReviewClick: () => void
}

export const ConfirmReviewAction = ({ reminder, onPlanReviewClick }: IConfirmReviewActionProps) => {
  const parsedActions = useMemo(() => {
    if (!reminder.Actions) {
      return []
    }
    return parseJson<ICommitmentReminderActionItem[]>(reminder.Actions) ?? []
  }, [reminder.Actions])

  if (reminder.Action === CommitmentReminderAction.ReviewPlanAction) {
    if (!parsedActions.length) {
      return (
        <Button
          className={styles.btn}
          variant={'outlined'}
          color={'success'}
          onClick={onPlanReviewClick}
        >
          <Translation text={PartnerCommitmentTranslations.ReviewPlan} />
        </Button>
      )
    }
    return <PlanReviewActions actions={parsedActions} />
  }

  return null
}
